import React, { useEffect } from 'react'
import event8 from './eventImg/event-16-2nd.webp'


const Event5 = () => {
    useEffect(() => {
        document.title = "An Online Webinar on World Technology Day";
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>16 May 2025</h1> 
<h3 className='text-center'>An Online Webinar on World Technology Day</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={event8} alt='An Online Webinar on World Technology Day'/>
<button className='mb-4'><a href='https://us02web.zoom.us/webinar/register/WN_zAoc_KkmQgOOOLaKWDqM-Q#/registration' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event5

